import React from 'react'
import { serverEnvI18n, ServerEnvironment } from '../server-environment'
import { FormattedMessage, useIntl } from 'react-intl'
import { css } from '@emotion/css'
import { AgentLanguage } from '../agent-language'
import {
  TextBar,
  TextBarItem
} from '@contrast-security-inc/design-system-data-bars'

const metadataListCss = css`
  margin-bottom: 10px;
`

export interface ServerMetadataProps {
  environment: ServerEnvironment
  path: string
  logLevel: string
  language?: string
  os?: string
}

export function ServerMetadata(props: ServerMetadataProps) {
  const { environment, path, logLevel, language, os } = props

  const serverEnvMessage = serverEnvI18n[environment]
  const { formatMessage } = useIntl()

  return (
    <TextBar className={metadataListCss}>
      <TextBarItem
        label={formatMessage({ id: 'title_environment_server' })}
        value={<FormattedMessage id={serverEnvMessage} />}
      />
      <TextBarItem
        label={formatMessage({ id: 'title_filesDirectory' })}
        value={path}
      />
      <TextBarItem
        label={formatMessage({ id: 'title_logLevel' })}
        value={logLevel}
      />
      {!!language &&
        AgentLanguage.fromValue(language).isDotNetFlavor() &&
        !!os && (
          <TextBarItem
            label={formatMessage({ id: 'title_operatingSystem_abbreviation' })}
            value={os}
          />
        )}
    </TextBar>
  )
}
